import { Variant } from "@/components/Types";
import { cn } from "@/lib/utils";
import { useState } from "react";

import BaseDropdown, { BaseDropdownOption } from "../BaseDropdown";

interface SimpleDropdownProps {
  variant: Variant;
  defaultOption?: string;
  options: BaseDropdownOption[];
  selectedOption: BaseDropdownOption;
  align: "left" | "right";
  onChange: (option: BaseDropdownOption) => void;
  className?: string;
  large?: boolean;
  disabled?: boolean;
}

const SimpleDropdown = ({
  variant,
  defaultOption,
  options,
  selectedOption,
  onChange,
  className,
  large,
  align,
  disabled,
}: SimpleDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <BaseDropdown
      label={defaultOption || selectedOption.label}
      open={open}
      setOpen={setOpen}
      variant={variant}
      className={className}
      large={large}
      align={align}
      disabled={disabled}
    >
      {options.map((option, index) => (
        <div
          className={cn(
            "flex justify-start items-center px-2 h-7 whitespace-nowrap cursor-pointer text-sm",
            selectedOption.value === option.value
              ? "bg-tertiary-button-active"
              : "hover:bg-tertiary-button-hover",
          )}
          key={index}
          onClick={() => {
            onChange(option);
            setOpen(false);
          }}
        >
          {option.label}
        </div>
      ))}
    </BaseDropdown>
  );
};

export default SimpleDropdown;
